import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = ({ onLogoClick }) => { // Add onLogoClick prop
  const location = useLocation();
  const navigate = useNavigate();

  // Handle logo click
  const handleLogoClick = (e) => {
    e.preventDefault();
    const currentPath = location.pathname;
    if (currentPath === '/') {
      if (onLogoClick) {
        onLogoClick();
      }
    } else {
      navigate('/');
    }
  };

  

  return (
    <footer className="footer">
      {/* Background SVG waves */}
      <div className="background">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1600 900"
        >
          <defs>
            <linearGradient id="bg" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgba(0, 100, 100, 0.4)' }} />
              <stop offset="100%" style={{ stopColor: 'rgba(0, 255, 255, 0.7)' }} />
            </linearGradient>
            <path
              id="wave"
              fill="url(#bg)"
              d="M-363.852,502.589c0,0,236.988-41.997,505.475,0
              s371.981,38.998,575.971,0s293.985-39.278,505.474,5.859
              s493.475,48.368,716.963-4.995v560.106H-363.852V502.589z"
            />
          </defs>
          <g>
            <use xlinkHref="#wave" opacity=".3">
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="translate"
                dur="8s"
                values="270 230; -334 180; 270 230"
                repeatCount="indefinite"
              />
            </use>
            <use xlinkHref="#wave" opacity=".6">
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="translate"
                dur="6s"
                values="-270 230;243 220;-270 230"
                repeatCount="indefinite"
              />
            </use>
            <use xlinkHref="#wave" opacity=".9">
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="translate"
                dur="4s"
                values="0 230;-140 200;0 230"
                repeatCount="indefinite"
              />
            </use>
          </g>
        </svg>
      </div>
      {/* Content */}
      <div className="footer-container">
        {/* Column 1 */}
        <div className="footer-about">
          <img
            src="/images/header2-logo.webp"
            alt="Oakya IT Logo"
            className="footer-logo"
            onClick={handleLogoClick}
            style={{cursor: 'pointer'}} // Add click handler and cursor pointer
          />
          <p>
            We combine creativity and expertise to deliver high-performing, responsive
            websites tailored to your needs. Our solutions enhance user experience and
            strengthen your online presence.
          </p>
        </div>
        {/* Column 2 */}
        {/* Column 2: Follow Us */}
<div className="footer-social">
  <h4>Follow Us</h4>
  <p>Join our community on social media.</p>

  <div className="social-icons">
    <a
      href="https://www.facebook.com/oakyaitservices"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Facebook"
    >
      <i className="fab fa-facebook-f"></i>
    </a>

    <a
      href="https://www.linkedin.com/company/oakya-it-services/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="LinkedIn"
    >
      <i className="fab fa-linkedin-in"></i>
    </a>

    <a
      href="https://x.com/oakyaitservices?s=21"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Twitter / X"
    >
      <i className="fab fa-twitter"></i>
    </a>

    <a
      href="https://www.instagram.com/oakya_itservices/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
    >
      <i className="fab fa-instagram"></i>
    </a>
  </div>
</div>

        {/* Column 3: Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link
        to="/"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        Home
      </Link></li>
            <li><Link to="/about#home">About Us</Link></li>
            <li><Link to="/expertise#expertise">Expertise</Link></li>
            <li><Link to="/portfolio#hero">Portfolio</Link></li>
            <li><Link to="/contact#oakya-contact">Contact</Link></li>
          </ul>
        </div>
        {/* Column 4 */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p>
            <img src="/images/phone.webp" alt="Phone" className="contact-icon" />
            <div className='footer-mobile-num'><a href="tel:+919134747474">+91 9134747474,</a>
            {/* <a href="tel:+919912566969">+91 9912566969</a> */}
            </div>
          </p>
          <p>
            <img src="/images/email.webp" alt="Email" className="contact-icon" />
            <a href="mailto:info@oakyaitservices.com">info@oakyaitservices.com</a>
          </p>
          <p>
            <img src="/images/address.webp" alt="Address" className="contact-icon" />
            <a
              href="https://www.google.com/maps?q=4th+Floor,+MKR+Enclave,+kamayyathopu,+Pantakaluva+Road,+NTR+Marg,+Kanuru,+Vijayawada,+Andhra+Pradesh"
              target="_blank"
              rel="noopener noreferrer"
            >
              4th Floor, MKR Enclave, kamayyathopu,
              Pantakaluva Road, NTR Marg, Kanuru,
              Vijayawada, Andhra Pradesh, 520007.
            </a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Oakya IT Services. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;